"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _Slide = _interopRequireDefault(require("@material-ui/core/Slide"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Transition = /*#__PURE__*/_react.default.forwardRef(function Transition(props, ref) {
  return /*#__PURE__*/_react.default.createElement(_Slide.default, _extends({
    direction: "up",
    ref: ref
  }, props));
});
/**
 * Standard dialog for showing prompts / alerts / messages
 * @param title     The title of the dialog
 * @param open      True if the dialog is open
 * @param onClose   Function for dismissing the dialog
 * @param children  Child components to render
 * @param actions   Items to render as Dialog Actions (usually buttons)
 */


var NICADialog = function NICADialog(_ref) {
  var title = _ref.title,
      open = _ref.open,
      onClose = _ref.onClose,
      children = _ref.children,
      actions = _ref.actions,
      maxWidth = _ref.maxWidth;
  return /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    open: open,
    onClose: onClose,
    TransitionComponent: Transition,
    maxWidth: maxWidth
  }, /*#__PURE__*/_react.default.createElement(_DialogTitle.default, null, title), /*#__PURE__*/_react.default.createElement(_DialogContent.default, null, children), /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, actions ? actions.map(function (action, index) {
    return action.loading ? /*#__PURE__*/_react.default.createElement("div", {
      className: "flex center w-20"
    }, /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
      size: 30
    })) : /*#__PURE__*/_react.default.createElement(_Button.default, {
      variant: "text",
      color: "primary",
      onClick: action.onClick,
      key: "dialog-action-".concat(index)
    }, action.label);
  }) : null));
};

NICADialog.propTypes = {
  title: _propTypes.default.string.isRequired,
  open: _propTypes.default.bool.isRequired,
  onClose: _propTypes.default.func.isRequired,
  children: _propTypes.default.any,
  actions: _propTypes.default.array,
  maxWidth: _propTypes.default.string
};
NICADialog.defaultProps = {
  maxWidth: "sm"
};
var _default = NICADialog;
exports.default = _default;